var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex filter_table"},[_c('div',{staticClass:"flex flex_column w_100"},[_c('CustomRatingTable',{attrs:{"filters":_vm.filters}})],1),_c('CustomRatingFilter',{on:{"apply-filter":_vm.applyFilter}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }